tetloose.embedVideo = function() {
    var $embedVideo = $('[rel=js-video]');
    if ($embedVideo.length) {
        $embedVideo.each(function(){
            var $t = $(this),
                $videoID = $t.data('video');

            $videoID = $videoID.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

            if($videoID[2] !== undefined) {
                $videoID = $videoID[2].split(/[^0-9a-z_\-]/i);
                $videoID = $videoID[0];
            }

            $t.append('<iframe src="https://www.youtube.com/embed/'+$videoID+'?autoplay=1" frameborder="0" allowfullscreen></iframe>');
        });
    }
};
